// Usage: import { PMT } from '@fitinsur/utils';
// Description: Function to calculate the price of installments
// Params: 
//    interestRate 
//    numberOfInstallments, 
//    totalAmount
//    futureValue
//    type

export function PMT(interestRate, numberOfInstallments, totalAmount, futureValue = 0, type = 0) {

  if (interestRate == 0) return (totalAmount + futureValue) / numberOfInstallments;

  const totalInterestRate = Math.pow(1 + interestRate, numberOfInstallments);
  let pmt = interestRate / (totalInterestRate - 1) * (totalAmount * totalInterestRate + futureValue);

  if (type == 1) {
    pmt /= (1 + interestRate);
  }

  return pmt;
}